import { ReactComponent as InfoIcon } from '../../../../icons/info.svg';

import { OkDialog } from '../ok-dialog/OkDialog';

export const InfoDialog = ({ isOpen, title, message, onClick, onClose }) => (
  <OkDialog
    isOpen={isOpen}
    title={title}
    message={message}
    onClick={onClick}
    onClose={onClose}
    icon={<InfoIcon width={56} height={56} style={{ color: '#2196f3' }} />}
  />
);
